export const generalKey = [ 'general' ]
export const generalSummaryKey = [ 'general', 'summary' ]
export const generalDelayCheckKey = [ 'general', 'delay', 'check' ]
export const searchHandlerKey = [ 'search', 'handler' ]
export const blockListKey = [ 'block', 'list' ]
export const blockDetailKey = [ 'block', 'detail' ]
export const blockTransactionListKey = [ 'transaction', 'list', 'block' ]
export const blockTransactionInternalListKey = [ 'block', 'transaction', 'internal', 'list' ]
export const blockSummaryKey = [ 'block', 'summary' ]
export const transactionListKey = [ 'transaction', 'list' ]
export const transactionDetailKey = [ 'transaction', 'detail' ]
export const transactionInternalListKey = [ 'transaction', 'internal', 'list' ]
export const transactionInternalTraceKey = [ 'transaction', 'internal', 'trace' ]
export const transactionPendingListKey = [ 'transaction', 'pending', 'list' ]
export const transactionLogListKey = [ 'transaction', 'log', 'list' ]
export const transactionSummaryKey = [ 'transaction', 'summary' ]
export const transactionEvmAbiMethodListKey = [ 'transaction', 'evm', 'abi', 'method', 'list' ]
export const addressListKey = [ 'address', 'list' ]
export const addressDetailKey = [ 'address', 'detail' ]
export const addressContractCodeKey = [ 'address', 'contract', 'code' ]
export const addressTransactionListKey = [ 'address', 'transaction', 'list' ]
export const addressTransactionInternalListKey = [ 'address', 'transaction', 'internal', 'list' ]
export const addressTransactionTokenListKey = [ 'address', 'transaction', 'token', 'list' ]
export const workerTransactionPendingStatusKey = [ 'worker', 'transaction', 'pending', 'status' ]
export const tokenDetailKey = [ 'token', 'detail' ]
export const tokenInfoKey = [ 'token', 'info' ]
export const erc20TransferListKey = [ 'token', 'erc20', 'transfer', 'list' ]
export const erc721TransferListKey = [ 'token', 'erc721', 'transfer', 'list' ]
export const erc1155TransferListKey = [ 'token', 'erc1155', 'transfer', 'list' ]
export const erc20HolderListKey = [ 'token', 'erc20', 'holder', 'list' ]
export const erc721HolderListKey = [ 'token', 'erc721', 'holder', 'list' ]
export const erc1155HolderListKey = [ 'token', 'erc1155', 'holder', 'list' ]
export const erc721InventoryListKey = [ 'token', 'erc721', 'inventory', 'list' ]
export const erc721InventoryListCountKey = [ 'token', 'erc721', 'inventory', 'list', 'count' ]
export const erc1155InventoryListKey = [ 'token', 'erc1155', 'inventory', 'list' ]
export const erc1155InventoryListCountKey = [ 'token', 'erc1155', 'inventory', 'list', 'count' ]
export const erc721ItemProfileKey = [ 'token', 'erc721', 'item', 'profile' ]
export const erc1155ItemProfileKey = [ 'token', 'erc1155', 'item', 'profile' ]
export const erc721ItemHolderKey = [ 'token', 'erc721', 'item', 'holder' ]
export const erc721ItemHolderHistoryListKey = [ 'token', 'erc721', 'item', 'holder', 'history', 'list' ]
export const erc1155ItemHolderListKey = [ 'token', 'erc1155', 'item', 'holder', 'list' ]
export const erc1155ItemHolderHistoryListKey = [ 'token', 'erc1155', 'item', 'holder', 'history', 'list' ]
export const erc721ItemActivityListKey = [ 'token', 'erc721', 'item', 'activity', 'list' ]
export const erc1155ItemActivityListKey = [ 'token', 'erc1155', 'item', 'activity', 'list' ]
export const analyticsUserMsuUniqueActiveWalletsKey = [ 'analytics', 'user', 'msu', 'uaw' ]
export const analyticsUserNewRegisteredUsersKey = [ 'analytics', 'user', 'new', 'registered', 'users' ]
export const analyticsUserTotalUsersKey = [ 'analytics', 'user', 'total', 'users' ]
export const analyticsUserRetentionRateKey = [ 'analytics', 'user', 'retention', 'rate' ]
export const analyticsUserSticknessKey = [ 'analytics', 'user', 'stickness' ]
export const analyticsUserMsnUniqueActiveWalletsKey = [ 'analytics', 'user', 'msn', 'uaw' ]
export const analyticsUserMsnUniqueActiveAddressesKey = [ 'analytics', 'user', 'msn', 'uaa' ]
export const analyticsNetworkTransactionCountKey = [ 'analytics', 'network', 'transaction', 'count' ]
export const analyticsTokenNesoHoldersKey = [ 'analytics', 'token', 'neso', 'holders' ]
export const analyticsTokenNxpcHoldersKey = [ 'analytics', 'token', 'nxpc', 'holders' ]
export const analyticsTokenNftHoldersKey = [ 'analytics', 'token', 'nft', 'holders' ]
export const analyticsMarketplaceTradersKey = [ 'analytics', 'marketplace', 'traders' ]
export const deployedContractListKey = [ 'deployted', 'contract', 'list' ]
export const nftTransferListKey = [ 'nft', 'transfer', 'list' ]
export const nftTradeListKey = [ 'nft', 'trade', 'list' ]
export const nftMintListKey = [ 'nft', 'mint', 'list' ]
export const latestMintKey = [ 'nft', 'mint', 'latest' ]
export const tokenCardListKey = [ 'token', 'card', 'list' ]
export const nftCardListKey = [ 'nft', 'card', 'list' ]
export const featureIndicatorKey = [ 'feature', 'indicator' ]
export const aiSummaryKey = [ 'ai', 'summary' ]
export const commonLandingKey = [ 'common', 'landing' ]
export const portfolioErc20HoldingListKey = [ 'portfolio', 'erc20', 'holding', 'list' ]
export const portfolioNftHoldingListKey = [ 'portfolio', 'nft', 'holding', 'list' ]
export const accountsTokenTransferListKey = [ 'accounts', 'token', 'transfer', 'list' ]
export const accountsNftTransferListKey = [ 'accounts', 'nft', 'transfer', 'list' ]
export const burnHistoryKey = [ 'tokenomics', 'burn', 'history' ]
